// extracted by mini-css-extract-plugin
module.exports = {"container":"partners_container__BgFLS","sheet":"partners_sheet__SSK_m","scroll":"partners_scroll__E2JvP","item":"partners_item__8rQhF"};